import React from 'react';
import { IconsPropsType } from './icons.config.type';

const ToUp: React.FC<IconsPropsType> = ({ style, color, onClick, className }) => {
  return (
    <svg
      style={{ ...style }}
      width="20"
      height="43"
      viewBox="0 0 20 43"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="12.7336" width="19" height="29" rx="2.5" stroke="black" />
      <path
        d="M10 0.599977L4 10.3222H7.32667L7.33333 25.6H12.6667L12.6667 10.3222H16L10 0.599977Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

    // </div>
  );
};

ToUp.defaultProps = {
  style: { width: '20px', height: '43px' },
  color: '#fff',
  onClick: undefined,
  className: undefined,
};

export default ToUp;
